<template>
  <div>
    <ValidationObserver ref="observer">
      <div class="mt-5 vx-row">
        <div class="vx-col w-full">
          <ul class="heading-ul mb-5">
            <li>
              <router-link
                :to="{ path: '/setup/media-pricing/event' }"
                class="vx-row"
              >
                <feather-icon icon="ArrowLeftIcon" svgClasses="text-dark" />
                <h4>{{ $t("setup.label.EditEvent") }}</h4>
              </router-link>
            </li>
          </ul>
        </div>
        <vx-card title no-shadow card-border>
          <div class="vx-row">
            <div class="vx-col w-full lg:w-1/2 md:w-1/2 sm:w-full xs:w-full">
              <ValidationProvider
                rules="required"
                v-slot="{ errors }"
                :name="$t('setup.label.EventCode')"
              >
                <vs-input
                  v-model="eventDataView.eventName"
                  :placeholder="$t('setup.label.EnterEventCode')"
                  :label="$t('setup.label.EventCode')"
                  class="w-full mb-5 font-semibold starlabel"
                />
                <span class="validate-error" style="color: red">{{
                  errors[0]
                }}</span>
              </ValidationProvider>
            </div>
            <div class="vx-col w-full lg:w-1/2 md:w-1/2 sm:w-full xs:w-full">
              <ValidationProvider
                rules="required"
                v-slot="{ errors }"
                :name="$t('setup.label.EventDescription')"
              >
                <vs-input
                  v-model="eventDataView.eventDescription"
                  :placeholder="$t('setup.label.EnterEventDescription')"
                  :label="$t('setup.label.EventDescription')"
                  class="w-full mb-5 font-semibold starlabel"
                />
                <span class="validate-error" style="color: red">{{
                  errors[0]
                }}</span>
              </ValidationProvider>
            </div>
            <div class="vx-col w-full lg:w-1/2 md:w-1/2 sm:w-full xs:w-full">
              <div class="dropdown-with-label">
                <small class="date-label"
                  >{{ $t("setup.label.EventCategory") }}
                  <span class="required"> *</span></small
                >
                <ValidationProvider
                  rules="required"
                  v-slot="{ errors }"
                  :name="$t('setup.label.EventCategory')"
                >
                  <v-select
                    label="mCodeValue"
                    v-model="eventDataView.eventCategory"
                    :options="eventTemplateData.eventCategeorydata"
                    :placeholder="$t('placeholder.label.SelectOne')"
                    :dir="$vs.rtl ? 'rtl' : 'ltr'"
                    :reduce="(status) => status.mCodeValue"
                    class="min-w-200 w-full mb-2"
                  >
                    <template v-slot:option="option">{{
                      option.mCodeValue
                    }}</template>
                  </v-select>
                  <span class="validate-error" style="color: red">{{
                    errors[0]
                  }}</span>
                </ValidationProvider>
              </div>
            </div>
            <div class="vx-col w-full lg:w-1/2 md:w-1/2 sm:w-full xs:w-full">
              <div class="dropdown-with-label">
                <small class="date-label"
                  >{{ $t("setup.label.ChargeCode") }}
                  <span class="required"> *</span></small
                >
                <ValidationProvider
                  rules="required"
                  v-slot="{ errors }"
                  :name="$t('setup.label.ChargeCode')"
                >
                  <v-select
                    label="chargeDescription"
                    v-model="eventDataView.chargeCode"
                    :options="eventTemplateData.chargeData"
                    :placeholder="$t('placeholder.label.SelectOne')"
                    :dir="$vs.rtl ? 'rtl' : 'ltr'"
                    :reduce="(data) => data.chargeCode"
                    class="min-w-200 w-full mb-2"
                  >
                    <template v-slot:option="option">{{
                      option.chargeDescription
                    }}</template>
                  </v-select>
                  <span class="validate-error" style="color: red">{{
                    errors[0]
                  }}</span>
                </ValidationProvider>
              </div>
            </div>
            <div class="vx-col w-full lg:w-1/2 md:w-1/2 sm:w-full xs:w-full">
              <div class="dropdown-with-label">
                <small class="date-label">{{
                  $t("setup.label.StartDate")
                }}</small>
                <ValidationProvider
                  rules="required"
                  v-slot="{ errors }"
                  :name="$t('setup.label.StartDate')"
                >
                  <datepicker
                    :placeholder="$t('placeholder.label.SelectDate')"
                    v-model="eventDataView.eventStartDate"
                    :dir="$vs.rtl ? 'rtl' : 'ltr'"
                    class="min-w-200 w-full"
                  />
                  <span class="validate-error" style="color: red">{{
                    errors[0]
                  }}</span>
                </ValidationProvider>
              </div>
            </div>
            <div class="vx-col w-full lg:w-1/2 md:w-1/2 sm:w-full xs:w-full">
              <div class="dropdown-with-label">
                <small class="date-label">{{
                  $t("setup.label.EndDate")
                }}</small>
                <ValidationProvider
                  rules="required"
                  v-slot="{ errors }"
                  :name="$t('setup.label.EndDate')"
                >
                  <datepicker
                    :placeholder="$t('placeholder.label.SelectDate')"
                    v-model="eventDataView.eventEndDate"
                    :dir="$vs.rtl ? 'rtl' : 'ltr'"
                    class="min-w-200 w-full"
                  />
                  <span class="validate-error" style="color: red">{{
                    errors[0]
                  }}</span>
                </ValidationProvider>
              </div>
            </div>
            <div class="vx-col w-full lg:w-1/2 md:w-1/2 sm:w-full xs:w-full">
              <div class="dropdown-with-label">
                <small class="date-label">{{
                  $t("setup.label.Validity")
                }}</small>
                <ValidationProvider
                  rules="required"
                  v-slot="{ errors }"
                  :name="$t('setup.label.Validity')"
                >
                  <datepicker
                    :placeholder="$t('setup.label.SelectEventValidity')"
                    v-model="eventDataView.eventValidity"
                    :dir="$vs.rtl ? 'rtl' : 'ltr'"
                    class="min-w-200 w-full"
                  />
                  <span class="validate-error" style="color: red">{{
                    errors[0]
                  }}</span>
                </ValidationProvider>
              </div>
            </div>
            <div class="vx-col w-full lg:w-1/2 md:w-1/2 sm:w-full xs:w-full">
              <div class="dropdown-with-label">
                <small class="date-label"
                  >{{ $t("setup.label.Status") }}
                  <span class="required"> *</span></small
                >
                <ValidationProvider
                  rules="required"
                  v-slot="{ errors }"
                  :name="$t('setup.label.Status')"
                >
                  <v-select
                    label="value"
                    v-model="eventDataView.statusId"
                    :options="eventTemplateData.statusData"
                    :placeholder="$t('placeholder.label.SelectOne')"
                    :dir="$vs.rtl ? 'rtl' : 'ltr'"
                    class="min-w-200 w-full mb-2"
                    :reduce="(status) => status.id"
                  >
                    <template v-slot:option="option">{{
                      option.value
                    }}</template>
                  </v-select>
                  <span class="validate-error" style="color: red">{{
                    errors[0]
                  }}</span>
                </ValidationProvider>
              </div>
            </div>
            <div class="vx-col w-full lg:w-1/2 md:w-1/2 sm:w-full xs:w-full">
              <div class="dropdown-with-label">
                <small class="date-label"
                  >{{ $t("setup.label.SelectedMediaService") }}
                  <span class="required"> *</span></small
                >
                <ValidationProvider
                  rules="required"
                  v-slot="{ errors }"
                  :name="$t('setup.label.SelectedMediaService')"
                >
                  <v-select
                    label="mediaTitle"
                    v-model="eventDataView.selectedMedia"
                    :options="eventTemplateData.mediaAsset"
                    :placeholder="$t('placeholder.label.SelectOne')"
                    multiple
                    :dir="$vs.rtl ? 'rtl' : 'ltr'"
                    class="min-w-200 w-full mb-2"
                  >
                    <template v-slot:option="option">{{
                      option.mediaTitle
                    }}</template>
                  </v-select>
                  <span class="validate-error" style="color: red">{{
                    errors[0]
                  }}</span>
                </ValidationProvider>
              </div>
            </div>
          </div>
        </vx-card>
      </div>
      <div class="vx-row center">
        <div class="vx-col w-full">
          <vs-button
            color="primary"
            type="border"
            class="mb-2 footerButton-cancel"
            @click="cancel"
            >{{ $t("setup.label.Cancel") }}</vs-button
          >
          <vs-button class="mr-3 mb-2 footerButton-next" @click="updateEvent">{{
            $t("setup.label.Update")
          }}</vs-button>
        </div>
      </div>
    </ValidationObserver>
  </div>
</template>
<script>
import vSelect from "vue-select";
import { mapState } from "vuex";
import moment from "moment";
import { ValidationProvider, ValidationObserver } from "vee-validate";
import Datepicker from "vuejs-datepicker";

export default {
  data() {
    return {
      eventCode: "",
      eventDescription: "",
      validity: "",
      dateFormat: "dd MMMM yyyy",
      locale: "en",
      chargeCode: "",
      eventCategory: "",
      status: "",
      availableMedia: [],
      startDate: "",
      endDate: "",
    };
  },
  components: {
    "v-select": vSelect,
    Datepicker,
    ValidationProvider,
    ValidationObserver,
  },

  computed: {
    ...mapState({
      eventTemplateData: (state) => state.mediaDetails.eventTemplate,
      eventDataView: (state) => state.mediaDetails.eventViewById,
    }),
  },
  methods: {
    async getEventTemplateData() {
      try {
        await this.$store.dispatch("mediaDetails/getEventTemplateAction");
      } catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
            `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
    },
    async updateEvent() {
      const isValid = await this.$refs.observer.validate();
      if (!isValid) return;

      const formattedStartDate = moment(
        this.eventDataView.eventStartDate
      ).format("dd MMMM yyyy HH:mm:ss");
      const formattedEndDate = moment(this.eventDataView.eventEndDate).format(
        "dd MMMM yyyy HH:mm:ss"
      );
      const validityDate = new Date(this.eventDataView.eventValidity);
      const formattedValidity = moment(validityDate).format("DD MMMM YYYY");
      const mediaIds = this.eventDataView.selectedMedia.map(
        (media) => media.mediaId
      );

      let payload = {
        id: this.id,
        data: {
          status: this.eventDataView.statusId,
          eventName: this.eventDataView.eventName,
          eventDescription: this.eventDataView.eventDescription,
          eventCategory: this.eventDataView.eventCategory,
          chargeCode: this.eventDataView.chargeCode,
          locale: "en",
          dateFormat: "DD MMMM YYYY",
          eventStartDate: formattedStartDate,
          eventEndDate: formattedEndDate,
          eventValidity: formattedValidity,
          mediaData: mediaIds,
        },
      };

      await this.$store.dispatch("mediaDetails/updateEventAction", payload);
      this.$router.push("/setup/media-pricing/event");
    },
    cancel() {
      this.$router.push("/setup/media-pricing/event");
    },
    async getEventData() {
      try {
        await this.$store.dispatch(
          "mediaDetails/viewEventDataByIdAction",
          this.id
        );
      } catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
            `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
    },
  },

  mounted() {
    this.id = this.$route.params.id;
    this.getEventData();
    this.getEventTemplateData();
  },
};
</script>
